export default function shouldShowABTest(orgId: number): boolean {
  return orgId % 2 === 0;
}
